export default __webpack_public_path__ + "static/logo-9f2a85e2088664acdf95d9c7543728a5.png";